module.exports = __webpack_public_path__ + "static/media/mtrew.dfe7b259.jpg";